export default __webpack_public_path__ + "static/media/phone_forwarded_teal.eba33adf.svg";